// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// 1. Import your StoreContextProvider
import { StoreProvider } from './context/StoreContext.jsx'; // Make sure this path is correct

// Inject Google Maps JS API script using .env variable
const mapsApiKey = process.env.REACT_APP_Maps_API_KEY;
if (mapsApiKey) {
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${mapsApiKey}&libraries=places`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
	<BrowserRouter basename="/">
    {/* 2. Wrap your App component with StoreContextProvider */}
    		<StoreProvider>
      			<App />
    		</StoreProvider>
	</BrowserRouter>
  </React.StrictMode>
);
